import {State} from "./state";
import {AppService} from "../app/app.service";
import {PageResponse} from "../util/page-response";

class StateService {

    static API_URL = "/api/estados/v2";

    static findAll = (page?: number, size?: number, sort?: string, filter?: string): Promise<PageResponse<State>> => {
        return AppService.getAuthorized(this.API_URL, {
            page: page,
            size: size,
            sort: sort,
            id: sort?.startsWith('id') ? filter : '',
            descricao: sort?.startsWith('descricao') ? filter : ''
        }).then((result) => {
            return result.data;
        }).catch(() => {
            return {
                content: [],
                totalElements: 0
            };
        })
    };

    static findOne(id: number) {
        return AppService.getAuthorized(this.API_URL + "/" + id)
            .then((result) => {
                return result.data;
            }).catch(() => {
                return null;
            })
    }

    static save(item: State) {
        if (item.id) {
            return AppService.postAuthorized(this.API_URL + "/" + item.id, item);
        } else {
            return AppService.postAuthorized(this.API_URL, item);
        }
    }

    static delete(id: number) {
        return AppService.deleteAuthorized(this.API_URL + "/" + id);
    }

    static createState() {
        const state: State = {
            descricao: '',
            sigla: ''
        };
        return state;
    }
}

export {StateService};
